<template>
    <div class="p-1">
        <div class="lite-product-lists rtl row" :style="liteProductListStyles">
            <LiteProductListItem v-for="item in products" :key="item.id" :item="item" :store-data="storeData" @view="handleViewProduct" />
        </div>
    </div>
</template>
  
<script setup>
import { computed } from 'vue'
import { breakpoint } from "../../utils"
import LiteProductListItem from "./ProductListItem.vue"

const props = defineProps({
    products: {
        type: Array,
        default: () => [],
    },
    storeData: Object,
})
const emit = defineEmits(['view'])

const isMobile = computed(() => breakpoint.value.xs || breakpoint.value.sm)
const liteProductListStyles = computed(() => {
    if (isMobile.value) {
        return {
        }
    }
    return {
    }
})

const handleViewProduct = (product) => {
    emit("view", product);
}

</script>

<style lang="scss" scoped>
.lite-product-lists {
    position: relative;
}
</style>
